module.exports = __webpack_public_path__ + "media/newstyle/images/book-type-red-d8e0871d6e6793f7e741348cecb9db51.svg";